var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOsApple = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 80,
    viewBox: "0 0 68 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2836 12.7715C49.1998 9.39152 51.1656 4.68392 50.6277 0C46.4251 0.16 41.3408 2.68459 38.3274 6.06055C35.6215 9.05651 33.2593 13.8436 33.8944 18.4355C38.5823 18.7835 43.3673 16.1554 46.2836 12.7715ZM56.7959 42.5C56.9132 54.6078 67.8786 58.6355 68 58.6875C67.911 58.9715 66.2486 64.4265 62.224 70.0664C58.7415 74.9384 55.1295 79.7905 49.4385 79.8945C43.8486 79.9945 42.0487 76.7188 35.6539 76.7188C29.2631 76.7188 27.265 79.7901 21.9744 79.9941C16.4816 80.1901 12.2952 74.7231 8.78839 69.8672C1.61294 59.9353 -3.86774 41.8003 3.49377 29.5605C7.15026 23.4846 13.6826 19.6312 20.7771 19.5352C26.1688 19.4352 31.2612 23.0117 34.5577 23.0117C37.8542 23.0117 44.0427 18.7118 50.5467 19.3438C53.2689 19.4517 60.9135 20.3954 65.8198 27.2793C65.4235 27.5153 56.6989 32.3802 56.7959 42.5Z",
    fill: ""
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOsApple);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/os_apple.8b00cd90a6108bda3b107d74012d4ddb.svg";